import { createSlice } from "@reduxjs/toolkit";
import { json, useNavigate } from "react-router-dom";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || {
    success: false,
    user: {},
    token: "",
  },
  auth: !!JSON.parse(localStorage.getItem("user")),
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginuser(state, action) {
      const newuser = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    logoutuser(state, action) {
      localStorage.setItem(
        "user",
        JSON.stringify({ success: false, user: {}, token: "" })
      );
      state.user = { success: false, user: {}, token: "" };
      state.auth = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loginuser, logoutuser } = userSlice.actions;

export default userSlice.reducer;
